import { CheckBox, CheckBoxGroup, CheckBoxGroupProps } from '@idexx-laboratories/spot-react';
import React from 'react';

interface CheckboxValueGroupProps extends Omit<CheckBoxGroupProps, 'onChange'> {
  label?: string;
  variant?: 'default' | 'horizontal';
  isRequired?: boolean;
  small?: boolean;
  values: readonly any[];
  displayField?: string;
  onChange: (
    indices: number[],
    addedIndex: number | undefined,
    removedIndex: number | undefined,
  ) => void;
  checkedIndices: number[];
  formatter?: (v: any) => string;
  disabledByIndex?: (index: number) => boolean;
  allDisabled?: boolean;
  elementsClass?: string;
}

const CheckboxValueGroup = (props: CheckboxValueGroupProps): React.JSX.Element => {
  const {
    small,
    values,
    displayField,
    onChange,
    formatter,
    checkedIndices,
    disabledByIndex,
    allDisabled,
    elementsClass,
    ...rest
  } = props;

  const formatValue = value =>
    formatter ? formatter(value) : displayField ? value[displayField] : value;

  const addIndex = (index: number): void =>
    onChange(checkedIndices.concat(index), index, undefined);

  const removeIndex = (index: number): void =>
    onChange(
      checkedIndices.filter(i => i !== index),
      undefined,
      index,
    );

  return (
    <CheckBoxGroup {...rest}>
      {values.map((value, index) => (
        <CheckBox
          id={`${rest.id}__${index}`}
          label={formatValue(value)}
          className={elementsClass}
          aria-label={formatValue(value)}
          key={displayField ? value[displayField] : value}
          checked={checkedIndices.includes(index)}
          disabled={allDisabled || disabledByIndex?.(index) || false}
          onChange={e => (e.target.checked ? addIndex(index) : removeIndex(index))}
          size={small ? 'small' : 'default'}
          data-testid={`${rest['data-testid']}-${formatValue(value)}-cb`}
        />
      ))}
    </CheckBoxGroup>
  );
};

export default CheckboxValueGroup;
